import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "location-card__head" }
const _hoisted_2 = { class: "bold" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "location-card__details"
}
const _hoisted_5 = { class: "info row" }
const _hoisted_6 = { class: "left col-9" }
const _hoisted_7 = {
  class: "bold location-card--item-name highlight",
  style: {"padding-right":"50px"}
}
const _hoisted_8 = { class: "location-card--item-code" }
const _hoisted_9 = { class: "right location-card--count col-3" }
const _hoisted_10 = {
  key: 0,
  class: "location-card--actions"
}
const _hoisted_11 = {
  key: 1,
  class: "location-card--header"
}
const _hoisted_12 = { class: "move--info" }
const _hoisted_13 = { class: "move--actions" }
const _hoisted_14 = { class: "location-barcode justify-center" }
const _hoisted_15 = {
  key: 1,
  class: "location-card--editor"
}
const _hoisted_16 = { class: "location-card__details" }
const _hoisted_17 = { class: "location-card--header" }
const _hoisted_18 = { class: "edit--item" }
const _hoisted_19 = { class: "edit--item-info" }
const _hoisted_20 = {
  class: "bold location-card--item-name",
  style: {"padding-right":"50px"}
}
const _hoisted_21 = { class: "location-card--item-code" }
const _hoisted_22 = { class: "edit--item-count" }
const _hoisted_23 = { class: "action--change-stock-item" }
const _hoisted_24 = { class: "tooltip" }
const _hoisted_25 = { class: "edit--actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_barcode = _resolveComponent("barcode")!
  const _component_input_header = _resolveComponent("input-header")!

  return (!$setup.location)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["location-card--container", { float: $props.float }]),
        style: _normalizeStyle({minWidth: $props.minWidth})
      }, _cache[10] || (_cache[10] = [
        _createElementVNode("div", { class: "location-card--placeholder placeholder error" }, "No location data", -1)
      ]), 6))
    : ($props.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["location-card--container", { float: $props.float }]),
          style: _normalizeStyle({minWidth: $props.minWidth})
        }, [
          _createElementVNode("header", _hoisted_1, [
            _createVNode(_component_q_btn, {
              class: "close-button",
              unelevated: "",
              round: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emitClose(false))),
              icon: "close"
            }),
            _createElementVNode("h4", _hoisted_2, _toDisplayString($setup.location?.name || $setup.location?.id || '...'), 1),
            ($setup.location.storage_location?.id)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_3, " — " + _toDisplayString($setup.location.storage_location?.id), 1))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h5", _hoisted_7, _toDisplayString($setup.location?.stock_item?.title || 'Item has no name'), 1),
                    _createElementVNode("h6", _hoisted_8, _toDisplayString(String($setup.location?.stock_item?.ean || '')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[11] || (_cache[11] = _createElementVNode("h5", { class: "bold highlight" }, "Count", -1)),
                    _createElementVNode("div", null, _toDisplayString($setup.location.count), 1)
                  ]),
                  _withDirectives(_createElementVNode("div", { class: "bold col-12 text-center location-card--info transiting-count error space-v1" }, _toDisplayString($setup.location.transiting) + " items currently being moved from this location", 513), [
                    [_vShow, $setup.location?.transiting]
                  ])
                ]),
                _cache[17] || (_cache[17] = _createElementVNode("hr", null, null, -1)),
                (!_ctx.moving && $setup.location?.sys)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      ($props.editable && $setup.location?.sys)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            class: "flex",
                            unelevated: "",
                            outline: "",
                            rounded: "",
                            size: "medium",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editing = true))
                          }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode("Adjust")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      ($props.movable)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 1,
                            class: "flex",
                            unelevated: "",
                            outline: "",
                            rounded: "",
                            size: "medium",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moving = true))
                          }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode("Move Item")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.moving && $setup.location?.sys)
                    ? (_openBlock(), _createElementBlock("header", _hoisted_11, [
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "move--header" }, [
                          _createElementVNode("h5", { class: "bold highlight" }, "Items to move")
                        ], -1)),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_q_input, {
                            modelValue: $setup.decoupledCount,
                            "onUpdate:modelValue": [
                              _cache[3] || (_cache[3] = ($event: any) => (($setup.decoupledCount) = $event)),
                              _cache[4] || (_cache[4] = ($event: any) => (_ctx.changed = true))
                            ],
                            editable: "",
                            inline: "",
                            type: "number",
                            step: 1,
                            min: 0,
                            max: $setup.location.count || 0,
                            placeholder: String($setup.decoupledCount || '-')
                          }, null, 8, ["modelValue", "max", "placeholder"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          ($props.movable)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                unelevated: "",
                                rounded: "",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.moving = false))
                              }, {
                                default: _withCtx(() => _cache[14] || (_cache[14] = [
                                  _createTextVNode("Cancel")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_q_btn, {
                            unelevated: "",
                            rounded: "",
                            outline: "",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.commitMove())),
                            size: "medium"
                          }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode("Start Moving")
                            ])),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  ($setup.location.id)
                    ? (_openBlock(), _createBlock(_component_barcode, {
                        key: 0,
                        class: "location-datamatrix",
                        "model-value": $setup.location.id,
                        format: "datamatrixrectangular",
                        "bar-width": 15,
                        "bar-height": 3,
                        title: $setup.location.storage_location?.id,
                        "large-title": ""
                      }, null, 8, ["model-value", "title"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("section", _hoisted_16, [
                  _createElementVNode("header", _hoisted_17, [
                    _createVNode(_component_input_header, {
                      class: "edit--id",
                      modelValue: $setup.location.id,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.location.id) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("h5", _hoisted_20, _toDisplayString($setup.location?.stock_item?.title || 'Item has no name'), 1),
                        _createElementVNode("h6", _hoisted_21, _toDisplayString(String($setup.location?.stock_item?.ean || '')), 1),
                        _createVNode(_component_q_btn, {
                          unelevated: "",
                          rounded: "",
                          onClick: $setup.searchStock
                        }, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createElementVNode("span", { class: "t-icon" }, "P", -1),
                            _createElementVNode("span", null, "Change Stock-item", -1)
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[19] || (_cache[19] = _createElementVNode("h5", { class: "bold highlight" }, "Count", -1)),
                        _createVNode(_component_q_input, {
                          modelValue: $setup.location.count,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.location.count) = $event)),
                          dense: "",
                          outlined: "",
                          type: "number",
                          min: 0,
                          max: $setup.location.count || 0,
                          step: 1,
                          placeholder: String($setup.location.count || '-')
                        }, null, 8, ["modelValue", "max", "placeholder"])
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_23, null, 512), [
                      [_vShow, $setup.location.count <= 0 && !_ctx.changed]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_24, _cache[20] || (_cache[20] = [
                      _createElementVNode("div", { class: "meta" }, "To change to location item, clear the items", -1),
                      _createElementVNode("div", { class: "meta" }, "from the location first by moving them to a new location", -1)
                    ]), 512), [
                      [_vShow, $setup.location.count > 0]
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      ($props.movable)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            unelevated: "",
                            rounded: "",
                            outline: "",
                            size: "medium",
                            onClick: $setup.emitSave
                          }, {
                            default: _withCtx(() => _cache[21] || (_cache[21] = [
                              _createTextVNode("Save")
                            ])),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      ($props.movable)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 1,
                            unelevated: "",
                            rounded: "",
                            size: "medium",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editing = false))
                          }, {
                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                              _createTextVNode("Cancel")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
        ], 6))
      : _createCommentVNode("", true)
}